import React from 'react';

const EnrollmentFormContent = () => {
  return (
    <div>
      <div className='text-red-600 text-center mt-8'>
        Kindly check your information before sending.
        This will serve as your data for the Insurance Enterprise USA.
      </div>
    </div>
  );
}

export default EnrollmentFormContent;
